export const defaultLaborSkills = {
  label_skill1: 'Ușor', label_skill2: 'Mediu', label_skill3: 'Complicat 1', label_skill4: 'Complicat 2',
  tarif_skill1: 0, tarif_skill2: 0, tarif_skill3: 0, tarif_skill4: 0,
};
export const skillLabel = (settings, skill) => settings?.[`label_skill${skill}`] || defaultLaborSkills[`label_skill${skill}`] || 'Nespecificat';
